import { render, staticRenderFns } from "./MyCompanyInventoryFormsNew.vue?vue&type=template&id=5015601a&"
import script from "./MyCompanyInventoryFormsNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyInventoryFormsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports